export enum IDTypeId {
    SAIDDocument = 1,
    Passport = 2,
    IDDocument = 3,
}
